import '@shopify/polaris/build/esm/styles.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';
import { IntercomProvider } from 'react-use-intercom';
import { store } from 'redux/store';
import router from 'routes';
import './App.css';

const INTERCOM_APP_ID = import.meta.env.VITE_APP_INTERCOM_APP_ID;

createRoot(document.getElementById('root')!).render(
    <>
        <IntercomProvider appId={INTERCOM_APP_ID}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
        </IntercomProvider>
    </>
);
